<template>
  <section id="service">
    <div class="service-container">
      <div class="grid-column ai-c jc-b margin-bottom-16">
        <div class="grid-column ai-c jc-s gap-20">
          <div class="page-label">
            Service
          </div>
          <!--          <button-->
          <!--            class="sac__button bg-primary"-->
          <!--            type="button"-->
          <!--            @click="toggleNewModal"-->
          <!--          >-->
          <!--            + New Service-->
          <!--          </button>-->
        </div>
        <div class="grid-column ai-c gap-16">
          <div class="search-container">
            <SACSearch
              darkMode
              :width="200"
              :height="40"
              :search="search"
              placeholder="Search"
              @input="(value) => changeServiceValues([{ field: 'serviceSearch', value }])"
            />
          </div>
          <div
            class="export-container"
            @click="exportLeadsList"
          >
            <button
              type="button"
              class="export-button"
            >
              <span v-if="!exporting">
                EXPORT
              </span>
              <span v-else>
                EXPORTING
                <img
                  src="@shared/assets/img/general/loading-white.svg"
                  alt="Exporting"
                >
              </span>
            </button>
            <div class="export-label-container">
              <span class="export-label">
                CSV
              </span>
            </div>
          </div>
          <SelectedPartner />
        </div>
      </div>
      <div class="margin-bottom-16">
        <ServiceQuickFilters
          :active="activeTab"
          :toggle="handleActiveTab"
        />
        <div class="margin-top-16">
          <ServiceFilters
            :filters="filters"
            :toggle="toggleFilter"
            :loadData="loadData"
          />
        </div>
      </div>
      <ServiceList />
    </div>
    <ServiceDetailSheet />
    <ActionModal />
    <AllServiceFilterOptions
      :loadData="loadData"
    />
  </section>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import adminMixin from '@shared/mixins/adminMixin';
import ServiceList from '@shared/components/service/ServiceList.vue';
import ServiceDetailSheet from '@shared/components/service/ServiceDetailSheet.vue';
import ActionModal from '@shared/components/service/ActionModal.vue';
import SACSearch from '@shared/components/sac/SACSearch.vue';
import exportToFile from '@shared/lib/util/exportToFile';
import ServiceQuickFilters from '@shared/components/service/ServiceQuickFilters.vue';
import ServiceFilters from '@shared/components/service/ServiceFilters.vue';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';
import AllServiceFilterOptions
  from '@shared/components/service/serviceFilter/AllServiceFilterOptions.vue';

export default {
  name: 'ServiceView',
  metaInfo: {
    title: 'SmartAC.com | Service',
  },
  components: {
    SelectedPartner,
    ActionModal,
    ServiceDetailSheet,
    ServiceList,
    SACSearch,
    ServiceQuickFilters,
    ServiceFilters,
    AllServiceFilterOptions,
  },
  mixins: [adminMixin, serviceMixin],
  data() {
    return {
      search: '',
      showSearch: false,
      exporting: false,
      activeFilter: 'pending',
    };
  },
  computed: {
    filters() {
      const sortByOptions = {
        pending: [
          { label: 'Unit Age', value: 'age' },
          { label: 'Distance', value: 'distance' },
          { label: 'Last Occurred', value: 'time' },
        ],
        scheduled: [
          { label: 'Unit Age', value: 'age' },
          { label: 'Service Type', value: 'serviceType' },
          { label: 'Date Created', value: 'dateCreated' },
        ],
        closed: [
          { label: 'Unit Age', value: 'age' },
          { label: 'Distance', value: 'distance' },
          { label: 'Date Created', value: 'dateCreated' },
        ],
      };

      return this.serviceFilters
        .map((filter) => {
          if (filter.key === 'sortBy') {
            return {
              ...filter,
              options: sortByOptions[this.activeTab] || filter.options,
            };
          }
          return filter;
        });
    },
  },
  watch: {
    isActioned() {
      this.loadData();
    },
    isNoteActioned() {
      this.getCustomerNotes();
    },
    selectedCorpId() {
      this.loadData();
      this.$store.dispatch('getAllTechnicians');
    },
  },
  mounted() {
    const { leadId, requestId } = this.$route.query;
    this.loadData(leadId, requestId);
    this.$store.dispatch('getAllTechnicians');
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.getLocation);
    } else {
      console.warn('Geolocation is not supported by this browser.');
    }
  },
  methods: {
    getCustomerNotes() {
      if (this.serviceInfo.customerId) {
        this.$store.dispatch('getCustomerNotes', this.serviceInfo.customerId);
      }
    },
    loadData(leadId, requestId) {
      if (this.activeTab === 'scheduled' || this.activeTab === 'incomplete') {
        this.$store.dispatch('getAllServiceJobs');
      } else {
        this.$store.dispatch('getAllServiceJobs', requestId);
        this.$store.dispatch('getAllServiceRequest', requestId);
        this.$store.dispatch('getAllLeads', leadId);
      }
      this.$store.dispatch('getServiceSummary');
    },
    toggleFilter() {
      this.$store.dispatch('changeServiceValues', [{
        field: 'showRightSidebar',
        value: !this.showRightSidebar,
      }]);
    },
    toggleNewModal() {
      const changes = [{
        field: 'actionModalView',
        value: 'new-service',
      }, {
        field: 'actionRequest',
        value: {},
      }, {
        field: 'showActionModal',
        value: true,
      }];
      this.$store.dispatch('changeServiceValues', changes);
    },
    handleActiveTab(currentTab) {
      const newFilters = this.serviceFilters.map((fo) => {
        const updated = { ...fo };
        if (currentTab === 'closed') {
          if (fo.key === 'dateCreated' && !fo.active) {
            updated.active = true;
            updated.activeOption = { value: 'lastWeek', label: 'Last Week' };
          }
        } else if (fo.key === 'dateCreated') {
          updated.active = false;
          updated.activeOption = { };
        }
        return updated;
      });
      this.$store.dispatch('changeServiceValues', [{
        field: 'serviceFilters',
        value: newFilters,
      }, {
        field: 'activeTab',
        value: currentTab,
      }]);
      this.loadData();
    },
    async exportLeadsList() {
      this.exporting = true;
      try {
        const data = await this.$store.dispatch('exportLeadsList');
        if (data) {
          exportToFile({
            data,
            filename: 'Leads List.csv',
          });
          this.$store.dispatch('showSuccessToast', {
            header: 'Export was successful.',
            message: 'Leads list was download as .CSV',
          });
        } else {
          this.$store.dispatch('showAlertToast', {
            header: 'There was an unexpected error exporting leads list.',
            message: 'Please try again or contact support',
          });
        }
      } catch (err) {
        console.error(err);
      }
      this.exporting = false;
    },
    getLocation(position) {
      const {
        coords: {
          latitude,
          longitude,
        },
      } = position;
      if (latitude && longitude) {
        this.$store.dispatch('changeServiceValues', [{
          field: 'currentPosition',
          value: position,
        }]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
section#service {
  display: flex;
  flex: 1;
  background: $BLACK;
  justify-content: center;
  padding: 50px 100px;
  .service-container {
    min-width: 80vw;
    .export-container {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:hover {
        .export-label-container {
          display: block;
        }
      }
      .export-label-container {
        display: none;
        position: absolute;
        background-color: $WHITE;
        top: 45px;
        padding: 7px 16px 7px 16px;
        box-shadow: 0px 3px 6px rgba(9, 15, 32, 0.07);
        border-radius: 6px;
        white-space: nowrap;
        z-index: 5;
        cursor: pointer;
        &:hover {
          display: block;
          background-color: $SUNSET100;
          &:after {
            border-bottom-color: $SUNSET100;
          }
        }
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 50%;
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-bottom-color: $WHITE;
          border-top: 0;
          margin-left: -8px;
          margin-top: -8px;
        }
        .export-label {
          width: 100%;
          font-size: 0.875rem;
          color: $BLACK;
        }
      }
      .export-button {
        height: 38px;
        padding: 0 8px;
        color: $N50;
        display: flex;
        align-items: center;
        white-space: nowrap;
        font-size: 0.875rem;
        font-weight: 700;
        border: 1px solid $N50;
        border-radius: 8px;
        line-height: 1;
        span {
          height: 100%;
          display: flex;
          align-items: center;
        }
        img {
          height: 40%;
          margin-left: 8px;
          filter: invert(50%);
        }
      }
    }
    .search-container {
      .search-button {
        padding: 4px 8px;
        height: 38px;
        background-color: $E4;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $WHITE;
        .search-icon {
          height: 18px;
          margin-right: 5px;
          filter: invert(100%);
        }
      }
      .search-input {
        height: 38px;
        background-color: $WHITE;
        padding-left: 12px;
        border-radius: 4px;
      }
    }
  }
}
</style>
